import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import EditTracking from '../editor/EditTracking';
import { trackingReset } from 'src/store/modules/trackings';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ],
    multi_sub_button: ['close - button1', 'close - button2', 'close - button3']
  }
};

const BottomSheetImageTracking: FC = () => {
  var currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  var tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
          
      .modal_wrapper {
        width: 100%;
        height: 32rem;

        position: absolute;
        bottom: 0;

        overflow: hidden;
        background-color: transparent;
      }

      .slick_wrapper {
        width: 100%;
        height: 15.5rem;
        outline: none;
        position: absolute;
        top: 0;
        left: 0;
      }
      .slick-track {
        display: flex;
      }
      .slick-track img {
        object-fit: cover;
      }

      .contents_wrapper {
        margin-top: 15.5rem;
        height: 16.5rem;
      }
      .contents_box {
        width: 100%;
        height: 8rem;
        padding: 1.5rem 0 0.5rem 0;
      }
      .contents_box .title {
        width: 100%;
        height: 2rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .contents_box .sub_title {
        width: 100%;
        height: 4rem;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }

      .btn_wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        position: relative;
      }
      .btn_wrapper div {
        height: 3rem;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper">
            <div className="contents_box"></div>
            <div className="btn_wrapper">
              <div className="style01 tracking_center">
                <EditTracking
                  value={tracking?.multi_button?.[currentIndex]}
                  type="multi_button"
                />
              </div>
              <div className="style02 tracking_center">
                <EditTracking
                  value={tracking?.multi_sub_button?.[currentIndex]}
                  type="multi_sub_button"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomSheetImageTracking;
